import { signOut } from 'firebase/auth'
import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import { auth } from '../firebase'
import TchatAvatar from '../images/TchatAvatar.png'

const SidebarNav = () => {
   const { user } = useAuth()

   const handleLogout = () => {
      signOut(auth)
   }

   return (
      <nav className='flex gap-8 items-center justify-between h-24 p-8 bg-purple-light'>
         <span className='text-5xl text-white font-bold tracking-tighter'>Tchat.</span>
         <div className='flex gap-6 items-center'>
            <img src={user.photoURL || TchatAvatar} alt="avatar" className='h-12 w-12 rounded-2xl border-2 border-purple-dark' />
            <span className='text-2xl'>{user.displayName?.split(' ')[0]}</span>
            <button className='text-xl bg-purple-light px-4 py-3 rounded-xl border-2 border-purple-dark' onClick={handleLogout}>Logout</button>
         </div>
      </nav>
   )
}

export default SidebarNav